import { render, staticRenderFns } from "./IframeModal.vue?vue&type=template&id=1817b522"
import script from "./IframeModal.vue?vue&type=script&lang=js"
export * from "./IframeModal.vue?vue&type=script&lang=js"
import style0 from "./IframeModal.vue?vue&type=style&index=0&id=1817b522&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports